import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
const navLinks = [{
  label: 'Home',
  path: '/'
}, {
  label: 'Services',
  path: '/services'
}, {
  label: 'NIPR/JWICS',
  path: '/nipr-jwics'
}, {
  label: 'Thought Leadership',
  path: '/thought-leadership'
}, {
  label: 'Case Studies',
  path: '/case-studies'
}];
export function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  return <nav className="sticky top-0 z-50 bg-white shadow-md border-b border-gray-100" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="flex items-center justify-between h-16" data-id="element-77">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/rgcJwPHo8cNW53rsocngGA/NewRiver-Logo-FC-1000x287v2.png" alt="New River Systems" className="h-10 w-auto" data-id="element-79" />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-1" data-id="element-80">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`px-3 py-2 text-sm font-medium font-body transition-colors relative ${isActive(link.path) ? 'text-nrs-blue' : 'text-gray-600 hover:text-nrs-blue'}`} data-id="element-81">
                {link.label}
                {isActive(link.path) && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-nrs-blue rounded-full" data-id="element-82" />}
              </Link>)}
            <Link to="/calculator" className="ml-3 px-4 py-2 bg-nrs-orange text-white text-sm font-semibold font-body rounded-md hover:bg-amber-500 transition-colors" data-id="element-83">
              Risk Calculator
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button className="md:hidden p-2 text-gray-600 hover:text-nrs-blue" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" data-id="element-84">
            {mobileOpen ? <XIcon className="h-6 w-6" data-id="element-85" /> : <MenuIcon className="h-6 w-6" data-id="element-86" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && <div className="md:hidden bg-white border-t border-gray-100 px-4 py-3 space-y-1" data-id="element-87">
          {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setMobileOpen(false)} className={`block px-3 py-2 text-sm font-medium rounded-md ${isActive(link.path) ? 'text-nrs-blue bg-nrs-light' : 'text-gray-600 hover:text-nrs-blue hover:bg-gray-50'}`} data-id="element-88">
              {link.label}
            </Link>)}
          <Link to="/calculator" onClick={() => setMobileOpen(false)} className="block px-3 py-2 text-sm font-semibold text-white bg-nrs-orange rounded-md text-center mt-2" data-id="element-89">
            Risk Calculator
          </Link>
        </div>}
    </nav>;
}